import { SettlementDebt } from '../../../models/Entities/SettlementDebt/SettlementDebt';

export interface CurrencyAmount {
    currency: string;
    amount: number;
}

export interface DebtsSummary {
    total: number;
    /** Con detalle de cashflow: sólo esas se pueden clasificar. */
    enriched: number;
    paid: number;
    pending: number;
    /** Saldo pendiente por moneda, sin mezclar monedas. */
    pendingByCurrency: CurrencyAmount[];
}

export const isDebtPaid = (debt: SettlementDebt): boolean =>
    !!debt.CashFlowDebt && (debt.CashFlowDebt.pendingAmount ?? 0) <= 0;

export const summarizeDebts = (debts: SettlementDebt[] | undefined): DebtsSummary => {
    const list = debts ?? [];
    const enriched = list.filter((debt) => !!debt.CashFlowDebt);
    const pendingSums = new Map<string, number>();

    enriched.forEach((debt) => {
        const pendingAmount = debt.CashFlowDebt.pendingAmount ?? 0;
        if (pendingAmount <= 0) return;
        const currency = (debt.CashFlowDebt.currencyCode || '').toUpperCase();
        pendingSums.set(currency, (pendingSums.get(currency) ?? 0) + pendingAmount);
    });

    const paid = enriched.filter(isDebtPaid).length;

    return {
        total: list.length,
        enriched: enriched.length,
        paid,
        pending: enriched.length - paid,
        pendingByCurrency: Array.from(pendingSums.entries())
            .map(([currency, amount]) => ({ currency, amount }))
            .sort((a, b) => a.currency.localeCompare(b.currency))
    };
};

export type DebtsTone = 'loading' | 'waiting' | 'empty' | 'pending' | 'paid';

/** El estado general del bloque, del que salen color y mensaje. */
export const debtsTone = (input: {
    summary: DebtsSummary;
    hasLoaded: boolean;
    settlementConfirmed: boolean;
}): DebtsTone => {
    if (input.summary.total > 0) return input.summary.pending > 0 ? 'pending' : 'paid';
    if (!input.hasLoaded) return 'loading';
    return input.settlementConfirmed ? 'waiting' : 'empty';
};
